import EditUsers from '@/pages/admin/EditUsers.vue'
import EditFacilities from '@/pages/admin/EditFacilities.vue'
import EditPages from '@/pages/admin/EditPages.vue'

import store from '@/store'

const usersPermissions = [ "create-user", "view-all-users", "edit-users" ]
const facilitiesPermissions = [ "register-nf", "view-all-nf", "edit-all-nf" ]
const pagesPermissions = [ "view-all-static-pages", "edit-static-pages", "create-static-page", "delete-static-page" ]

const routes = [
    {
        path: '/admin/users',
        name: 'AdminEditUsers',
        component: EditUsers,
        meta: {
            auth: true,
            gate: () => usersPermissions.some(p => store.state.auth.permissions.includes(p))
        }
    }, {
        path: '/admin/facilities',
        name: 'AdminFacilities',
        component: EditFacilities,
        meta: {
            auth: true,
            gate: () => facilitiesPermissions.some(p => store.state.auth.permissions.includes(p))
        }
    }, {
        path: '/admin/pages',
        name: 'AdminPages',
        component: EditPages,
        meta: {
            auth: true,
            gate: () => pagesPermissions.some(p => store.state.auth.permissions.includes(p))
        }
    }
]

const adminRoutes = [
    { path: '/admin', name: 'AdminParentRoute', meta: { auth: true }, redirect: {name: 'AdminFacilities'}, children: routes }
]

export default adminRoutes